import React from 'react';
import { StyledSvg, iconGenerator } from '../Icon';
const MinusIcon = ({ size, color, deg, e2eId, }) => (React.createElement(StyledSvg, { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20", size: size, color: color, deg: deg, "data-e2e-id": e2eId },
    React.createElement("rect", { width: "16", height: "1.5", x: "2", y: "9.25", fillRule: "evenodd", rx: ".75" })));
export const Minus = iconGenerator(MinusIcon);
//# sourceMappingURL=Minus.js.map